<template>
    <div class="user-subscriptions-panel">
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            hide-default-footer
        >
            <template #[`item.created`]="{ item }">
                {{ $date.format(item.created_at) }}
            </template>

            <template #[`item.overdue_since`]="{ item }">
                {{ item.overdue_since === null ? 'Não' : 'Sim' }}
            </template>

            <template #[`item.current_period.cycle`]="{ item }">
                {{ item.current_period?.cycle || '-' }}
            </template>

            <template #[`item.status`]="{ item }">
                <r-chip-status
                    :value="item.status"
                    :items="$subscription.statuses"
                    small 
                />
            </template>

            <template #[`item.actions`]="{ item }">
                <v-btn
                    icon
                    :to="`/users/${user._id}/subscriptions/${item.id}`"
                >
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            loading: false,
            items: [],
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Plano', value: 'plan.name' },
                { text: 'Ciclos', value: 'current_period.cycle' },
                { text: 'Em atraso?', value: 'overdue_since' },
                { text: 'Status', value: 'status' },
                { text: 'Criação', value: 'created' },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
        }
    },
    computed: {
        user: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    methods: {
        async load() {
            this.loading = true 

            const response = await this.$api.getUserSubscriptions({
                user_id: this.user._id
            })

            if (response.error) {
                this.loading = false
                this.$router.replace(`/users/${this.user._id}`)
                return
            }

            this.items = response.message || []

            setTimeout(() => {
                this.loading = false
            }, 500)
        },
    },
    watch: {
        user: {
            immediate: true,
            handler: 'load'
        }
    },

}
</script>

<style scoped>
.user-subscriptions-panel >>> .v-data-table {
    background: transparent !important;
}
</style>
